/**
 * @generated SignedSource<<338c2908a1e5290b3619caf76072166a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckIsSeriesArticle$data = {
  readonly articleTypes: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersCheckIsSeriesArticle";
};
export type helpersCheckIsSeriesArticle$key = {
  readonly " $data"?: helpersCheckIsSeriesArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsSeriesArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckIsSeriesArticle"
};

(node as any).hash = "f9feefa9594ca95e78b8f2198cf61f4a";

export default node;
